<script setup>
import { ref } from 'vue'
import ContractCard from '../components/ContractCard.vue'
import { useRoute } from 'vue-router';
import { useAssessmentsStore, useAuthStore } from '../stores';

const route = useRoute()
const assessmentsStore = useAssessmentsStore()
const authStore = useAuthStore()
const assessment = ref({})
assessment.value = assessmentsStore.readinessAssessments[route.params.id]
</script>
<template>
    <Suspense>
        <template #fallback>
            Loading
        </template>
        <ContractCard />
    </Suspense>
</template>